// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
import Cookies from 'universal-cookie';

function backFillAriaLabelledBy(id: string) {
    const element = document.getElementById(id);
    if (element && !element.hasAttribute("aria-labelledby")) {
        const errorId = `${id}_errors`;
        const errorElement = document.getElementById(errorId);
        if (errorElement) {
            const ariaAttrNode = document.createAttribute("aria-labelledby");
            ariaAttrNode.value = errorId;
            element.setAttributeNode(ariaAttrNode);
        }
    }
}

function getPropertiesIds(properties: any) {
    const Ids: string[] = [];
    Object.keys(properties).map((item) => Ids.push(`root_${item}`));
    return Ids;
}

function getVerifyCookie() {
    return "hatchet.ai.cookie"
}

function getAdminCookie() {
    return "hatchet.ai.admin"
}

function getAuthQuery() {
    const search = window.location.search;
    const params = new URLSearchParams(search);
    const auth = params.get("auth");

    return auth
}

function getCookieValue(): string {
    const cookies = new Cookies();
    return cookies.get(getVerifyCookie());
}

function getLoginCookie(): string {
    return getCookieByName('HatchetCookieAuth');
}

function getCookieByName(name): string {
    const cookies = document.cookie.split(';');
    for (let cookie of cookies) {
      const [cookieName, cookieValue] = cookie.split('=');
      if (cookieName.trim() === name) {
        return decodeURIComponent(cookieValue);
      }
    }
    return '';
};

function getCookieEmail(): string {
    const cookies = new Cookies();
    const value = cookies.get(getVerifyCookie());
    if (value) {
        let decrypted = atob(value)
        const arr = decrypted.split(',')
        return arr[1]
    }
    return null
}

function getCookieRole(): string {
    const cookies = new Cookies();
    const value = cookies.get('hatchet.ai.role.cookie');
    if (value) {
        let decrypted = atob(value);
        return decrypted;
    }
    return null
}

function clearCookieAuth() {
    const cookies = new Cookies();
    let now = new Date();
    now.setDate(now.getDate() - 10);
    cookies.set(getVerifyCookie(), null, {
        path: "/",
        expires: now,
    });

    cookies.set(getAdminCookie(), null, {
        path: "/",
        expires: now,
    });

    cookies.set('hatchet.ai.role.cookie', null, {
        path: "/",
        expires: now,
    });
}

function getCookieName(): string {
    const cookies = new Cookies();
    const value = cookies.get(getVerifyCookie());
    if (value) {
        let decrypted = atob(value)
        const arr = decrypted.split(',')
        return arr[0]
    }
    return null
}

function getCookieAdmin(): boolean {
    const cookies = new Cookies();
    return cookies.get(getAdminCookie());
}

function parseEndpointByType(method: string) {
    return process.env.REACT_APP_HACHET_API_URL + method;
}

function setAdminValue() {
    const cookies = new Cookies();
    let now = new Date();
    now.setDate(now.getDate() + 1);

    cookies.set(getAdminCookie(), true, {
        path: "/",
        expires: now,
    });
}

function setCookieValue(value: string) {
    const cookies = new Cookies();
    let now = new Date();
    now.setDate(now.getDate() + 1);

    const encryptedValue = btoa(value);
    cookies.set(getVerifyCookie(), encryptedValue, {
        path: "/",
        expires: now,
    });
}

function setCookieRoleValue(value: string) {
    const cookies = new Cookies();
    let now = new Date();
    now.setDate(now.getDate() + 10000);

    const encryptedValue = btoa(value);
    cookies.set('hatchet.ai.role.cookie', encryptedValue, {
        path: "/",
        expires: now,
    });
}

function baseUrl(key?: string, value?: any) {
    return window
        ? `${window.location.protocol}//${window.location.host}${window.location.pathname}${value ? `?${key}=` + value : ''}`
        : "";
}

export { backFillAriaLabelledBy, getPropertiesIds, getVerifyCookie, getAuthQuery, parseEndpointByType, getCookieValue, setCookieValue, getCookieEmail, getCookieName, clearCookieAuth, baseUrl, setAdminValue, getCookieAdmin, setCookieRoleValue, getCookieRole, getLoginCookie };